export default __webpack_public_path__ + "static/media/GR00008-yoga_picture_simple.051e3c41.svg";